import classNames from 'classnames';
import { Spacer } from '../Spacer';

export interface TileImageSkeletonProps {
  bgColor?: string;
  large?: boolean;
  small?: boolean;
  wide?: boolean;
}

export const TileImageSkeleton = ({
  small,
  wide,
  large,
  bgColor = 'bg-ds-natural-50',
}: TileImageSkeletonProps) => {
  return small ? (
    <div className="w-full h-full p-2.5 animate-pulse">
      <div className={classNames('w-full h-ds-26 rounded-md', bgColor)} />
      <Spacer amount={2} />
      <div className={classNames('w-2/3 h-3.5 rounded-md', bgColor)} />
    </div>
  ) : (
    <div className="p-2.5 animate-pulse">
      <div
        className={classNames(
          'rounded-md w-full',
          wide ? 'h-ds-29' : ' h-ds-34',
          bgColor
        )}
      />
      <Spacer amount={2} />
      {large ? (
        <>
          <div className="w-full h-3.5 rounded-md bg-ds-accent3-100" />
          <Spacer amount={2} />
          <div className="w-full h-3.5 rounded-md bg-ds-accent3-100" />
          <Spacer amount={2} />
          <div className="w-1/3 h-3.5 rounded-md bg-ds-accent3-100" />
        </>
      ) : (
        <div className={classNames('rounded-md h-3.5 w-2/3 ', bgColor)} />
      )}
    </div>
  );
};
